import { render } from "./VideoPage.vue?vue&type=template&id=3ac2ece6"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"

import "./video.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/richcle-kyc-fe/richcle-kyc-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__